import { useEffect } from 'react'
import {
  ConversationContent,
  ConversationMessageField,
  ConversationMessagesContext,
  TypingContent,
} from 'widgets/ConversationMessages'
import { useSectionMessagesContext } from 'pages/conversations/pages/search/pages/profile/ui/SectionMessages/context/sectionMessagesContext'
import styles from './styles.module.scss'

export const MessagesList = () => {
  const store = useSectionMessagesContext()
  const conversation = store.conversation
  const messagesStore = store.conversationMessagesStore

  useEffect(() => {
    store.init()

    return () => {
      store.dispose()
    }
  }, [])

  useEffect(() => {
    if (conversation) {
      const id = conversation.id

      messagesStore.setConversationId(id)

      if (id !== 0) {
        messagesStore.loadConversation()
      }
    }

    return () => {
      messagesStore.resetConversationId()
      messagesStore.reset()
    }
  }, [conversation])

  return (
    <div className={styles.wrap}>
      <ConversationMessagesContext.Provider value={messagesStore}>
        <ConversationContent virtualized />
        <TypingContent />
        <ConversationMessageField inboxId={store.inbox?.id} />
      </ConversationMessagesContext.Provider>
    </div>
  )
}
